import iosSvg from '@/assets/device-icons/ios-branded.svg';

interface IosIconProps {
  className?: string;
}

export const IosIcon = ({ className = "h-5 w-5" }: IosIconProps) => {
  return (
    <img 
      src={iosSvg} 
      alt="iOS" 
      className={className}
    />
  );
};
